<template>
  <div>
    <!-- search -->
    <search-nav @handleSearch="onClickSearch">
      <div class="search-layout w-full grid col-gap-4 flex-wrap xl:flex ">
        <component
          v-for="(component, index) in stdSearchComponents"
          v-if="showSearchNavItem(component['options'])"
          :is="component['component']"
          :label="component['label']"
          :query="component['query']"
          :options="component['options']"
          :onClickSearch="onClickSearch"
          v-model="nav.value[component['value']]"
        />
      </div>
    </search-nav>

    <!-- list -->
    <div>
      <fragment v-if="mode === 'popup'">
        <div class="w-full flex">
          <div class="flex mr-auto mb-4">
            <vs-select v-model="perPage" autocomplete class="mr-4" style="width: 110px;" >
              <vs-select-item v-for="v in [10, 20, 30, 50]" :text="`${v}개씩 보기`" :value="v" />
            </vs-select>
          </div>
        </div>
      </fragment>
      <fragment v-else>
        <div class="pl-2 xl:pl-0 mb-4 flex items-center " style="font-size: 18px;">
          <span class="mr-2" style="font-weight: 700;">표시된 공정 수 : </span>
          <span>{{ total }}건</span>
        </div>

        <div class="w-full flex">
          <div class="flex mr-auto mb-4">
            <vs-select v-model="perPage" autocomplete class="mr-4" style="width: 110px;" >
              <vs-select-item v-for="v in [10, 20, 30, 50]" :text="`${v}개씩 보기`" :value="v" />
            </vs-select>
          </div>
          <div class="flex ml-auto gap-2">
            <vs-button color="secondary" type="border" class="mb-4 flex-1 xl:flex-none" @click="isEditMode = !isEditMode; editIndex=-1">{{ isEditMode ? '닫기' : '편집' }}</vs-button>
            <vs-button color="secondary" class="mb-4 flex-1 xl:flex-none" @click="showPopup = true">신규등록</vs-button>
          </div>
        </div>
      </fragment>
      <div class="list" :class="{'update': isEditMode}">
        <div class="list-header list-grid">
          <div>사업장명</div>
          <div>팀명</div>
          <div>공장명</div>
          <div>공정명</div>
          <div>상태</div>
          <div>활동명</div>
          <div class="list-edit">수정/삭제</div>
        </div>
        <div class="list-body">
          <div v-for="(data, index) in list"
               class="list-grid"
               :class="{'active': mode === 'popup' && data.id === selectData.id,
                        'cursor-pointer': mode === 'popup'}"
               @click="onClickItem(data)">
            <template v-if="editIndex !== index">
              <div>{{ data.body.사업장 ? data.body.사업장.field_name : '' }}</div>
              <div>{{ data.body.팀명 }}</div>
              <div>{{ data.body.공장명 }}</div>
              <div>{{ data.body.공정명 }}</div>
              <div>{{ data.body.상태 }}</div>
              <div>{{ data.body.활동명 }}</div>
              <div class="list-edit">
                <!-- 편집 / 삭제 -->
                <div class="flex justify-center gap-3">
                  <button class="p-2" @click="onClickEdit(index)">
                    <feather-icon icon="Edit2Icon" svgClasses="h-5 w-5" />
                  </button>
                  <button class="p-2" @click="onClickDelete(index)">
                    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5" />
                  </button>
                </div>
              </div>
            </template>

            <template v-else>
              <div><field-selector v-model="editData.body.사업장.id" @select="(field)=>{editData.body.사업장.field_name = field.field_name}"/></div>
              <div><ml-input v-model="editData.body.팀명"/></div>
              <div><ml-input v-model="editData.body.공장명"/></div>
              <div><ml-input v-model="editData.body.공정명"/></div>
              <div>
                <vs-select class="w-full" v-model="editData.body.상태" autocomplete>
                  <vs-select-item v-for="상태 in ['정상', '비정상', '비상',]" :text="상태" :value="상태" />
                </vs-select>
              </div>
              <div><ml-input v-model="editData.body.활동명"/></div>
              <div class="list-edit">
                <!-- 완료 / 닫기 -->
                <div class="flex justify-center gap-3">
                  <button class="p-2" @click="onClickEditSave">
                    <feather-icon icon="CheckIcon" svgClasses="h-5 w-5" />
                  </button>
                  <button class="p-2" @click="onClickEditClose">
                    <feather-icon icon="XIcon" svgClasses="h-5 w-5" />
                  </button>
                </div>
              </div>
            </template>

          </div>
        </div>
      </div>

      <div class="vs-con-table">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination :total="lastPage ? lastPage : 0" v-model="page" @change="onChangePage"></k-pagination>
        </div>
      </div>
    </div>

    <div v-if="mode === 'popup'" class="flex justify-end gap-4">
      <vs-button color="#DCDFE2" text-color="black" @click="$emit('close')">닫기</vs-button>
      <vs-button color="secondary" @click="$emit('select', selectData)">등록</vs-button>
    </div>

    <!-- write -->
    <popup-create893 v-model="showPopup" :board="board" :header="header" @save="onClickPopupSave"/>
  </div>
</template>

<script>

import SearchNav from "@/components/nav/SearchNav.vue";
import SearchColumnKeyword from "@/views/list/components/SearchColumnKeyword.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import PopupCreate893 from "./PopupCreate893.vue";
import List from "./List.js";
import searchComponent from "@/views/list/components/include";
import KPagination from "@/components/kPagination/kPagination.vue";

export default {
  components: {
    KPagination,
    PopupCreate893,
    FieldSelector,
    SearchColumnKeyword,
    SearchNav
  },
  props: {
    isPrint: Boolean,
    board: Object,
    header: Object,
    value: Object,
    mode: {
      type: String,
      default: "list"
    }
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    boardId() {
      return 893;
    },
    stdSearchComponents() {
      const getComponents = List.components
      if (getComponents) {
        const stdSearchComponents = getComponents();
        if (stdSearchComponents && stdSearchComponents.length > 0) {
          for (const component of stdSearchComponents) {
            component.component = searchComponent[component['component']];
          }
        }
        return stdSearchComponents;
      }
      return [];
    },
  },
  watch : {
    perPage () {
      this.loadListBoard()
    }
  },
  data() {
    return {
      nav: {
        value: {},
      },
      showPopup: false,
      isEditMode: false, // 편집모드 상태인지
      askForDelete: true, // 삭제 확인창
      selectData: {
        id: 0
      }, // 선택한 데이터 (popup 모드일 때 사용가능)

      editIndex: -1, // 수정중인 인덱스
      editData: {}, // 수정중인 데이터

      page: 1,
      lastPage: 1,
      perPage: 20,
      total: 0,
      list:[],

      form: {
        사업장: {},
        팀명: '',
        공장명: '',
        공정명: '',
        상태: '',
        활동명: '',
      }
    };
  },
  created() {
    this.loadListBoard()
  },
  methods: {
    showSearchNavItem(options) {
      if (options && options.visibleKeyValue) {
        for (const keyValue of options.visibleKeyValue) {
          const key = Object.keys(keyValue)[0];
          const value = keyValue[key];
          const navValue = this.findJsonDataWithDottedPath(this.nav.value, key);
          if (navValue !== value) {
            if (Array.isArray(navValue) && navValue.toString() === value) {
              return true;
            }
          } else {
            return true;
          }
        }
        return false;
      }
      return true;
    },
    async loadListBoard () {

      const conditions = List.getConditions(this.nav);
      const options = {
        projectId: this.projectId,
        boardId: this.boardId,
        page: this.page,
        perPage: this.perPage,
        conditions,
      }

      const response = await this.$store.dispatch("board/LOAD_POST_LIST", options);

      this.list = response.data.map((data) => {return {id: data.id, ...JSON.parse(data.post_content)}});
      this.total = response.total;
      this.lastPage = response.last_page;
      this.page = (this.page > this.lastPage) ? this.lastPage : this.page
    },
    onClickSearch () {
      this.page = 1
      this.loadListBoard()
    },
    onChangePage (page) {
      this.page = page
      this.loadListBoard()
    },
    onClickEdit(index) {
      this.editIndex = index
      this.editData = JSON.parse(JSON.stringify(this.list[index]))
    },
    async onClickDelete(index) {

      if (this.askForDelete) {
        let title = `사업장명: ${this.list[index].body.사업장.field_name}`;
        title += `<br/>팀명: ${this.list[index].body.팀명}`;
        title += `<br/>공장명: ${this.list[index].body.공장명}`;
        title += `<br/>공정명: ${this.list[index].body.공정명}`;
        title += `<br/>상태: ${this.list[index].body.상태}`;
        title += `<br/>활동명: ${this.list[index].body.활동명}`;
        title += '<br/><br/>데이터를 삭제하시겠습니까?'
        this.customConfirm(title, {
          confirmBtn: '삭제',
          confirmFunction: async () => {
            await this.delete(this.list[index].id)
            await this.loadListBoard()
          },

          cancelBtn: '더 이상 묻지않기',
          cancelFunction: async () => {
            this.askForDelete = false
            await this.delete(this.list[index].id)
            await this.loadListBoard()
          }
        })
      } else {
        await this.delete(this.list[index].id)
        await this.loadListBoard()
      }

    },
    async onClickEditSave() {
      if (!this.editData.body.사업장.id) {
        this.customAlert("사업장을 선택해주세요", "수정")
      } else {
        this.list[this.editIndex] = this.editData;
        const id = this.editData.id
        delete this.editData.id
        await this.update(id, this.editData)
        this.editData.id = id
        this.editIndex = -1
      }
    },
    onClickEditClose() {
      this.editIndex = -1
    },
    onClickPopupSave () {
      this.loadListBoard()
    },

    async update(postId, form) {
      form.header.full = `${form.header.year}-${form.header.month > 9 ? form.header.month : `0${form.header.month}`}-01`;

      const projectId = this.projectId;
      const boardId = this.boardId;
      const content = JSON.stringify(form);

      await this.$store.dispatch("board/UPDATE_POST", {
        projectId,
        boardId,
        postId,
        content,
      });
    },

    async delete (postId) {
      const boardId = this.boardId;
      await this.$store.dispatch("board/DELETE_POST", { boardId, postId });
    },

    customAlert(msg, title) {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: title || "공정활동분류표",
          message: msg,
        },
      });
      window.dispatchEvent(customAlert);
    },
    customConfirm(msg, options) {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: "공정활동분류표",
          message: msg,
          useConfirm: true,
          confirmBtn: options.confirmBtn || "확인",
          confirmFunction: options.confirmFunction,
          cancelBtn: options.cancelBtn || "닫기",
          cancelFunction: options.cancelFunction,
        },
      });
      window.dispatchEvent(customAlert);
    },

    onClickItem (data) {
      if (this.selectData === data) {
        this.$emit('select', this.selectData)
      } else {
        this.selectData = data
      }
    },

    // popupSelect893 에서 사용함
    reset () {
      this.selectData = {id: 0}
      this.askForDelete = true
      this.editData = {}
      this.editIndex = -1
      this.page = 1,
        this.lastPage = 1,
        this.perPage = 20,
        this.total = 0,
        this.list = []
    }
  }
};
</script>
<style lang="scss" scoped>
.list {
  text-align: center;

  .list-header {
    background-color: #f5f5f5;
    font-weight: 700;
    border-top: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }
  .list-body {
    background-color: #ffffff;
    & > div { border-bottom: 1px solid #e0e0e0; }
    & > div:hover { background-color: #f5f5f5; color: #000; font-weight: bold }
    & > div.active { background-color: #7E72F299; color: #fff }
  }

  .list-grid {
    display: grid;
    grid-template-columns: repeat(6, minmax(140px, 1fr));

    & > div {
      padding: 10px 4px;
      justify-content: center;
      align-content: center;
    }
  }
  .list-edit {
    display: none;
  }

  button {
    width: 32px;
    height: 32px;

    display: flex;
    align-items: center;
    justify-content: center;

    color: #7e72f2;
    background: none;
    border: 1px solid #7e72f2;
    border-radius: 4px;
    cursor: pointer;

    span {
      margin: 0;
    }
  }



  &.update {
    .list-grid {
      grid-template-columns: repeat(6, minmax(140px, 1fr)) 94px;
    }
    .list-edit {
      display: flex;
    }
  }
}
</style>
